import React, { FunctionComponent } from "react";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import awaitingType from "./types/awaitingType";
import {
  Wrapper,
  Header,
  AgentWrapper,
  AgentDetails,
  Avatar,
  AvatarImage,
  Tooltip,
  Requested,
  NameLink,
  StarRating,
  StarRatingLabel,
  FillRating,
  EmptyRating,
  Stars,
  NoRatings,
  HHScore,
  Score,
} from "./styles/awaiting-styles";
import { NewBadge, NewBadgeWrapper } from "./styles/new-badge-styles";
import {
  Name,
  TextDetails,
  Company,
} from "./styles/pending-invitations-styles";

export interface IAgent {
  name: string;
  company: string;
  avatar: string;
  starRatingPercent: number;
  hhScore: number;
  isNew: boolean;
  psl: boolean;
  id: number;
  agentUrl: string;
  activeSince: string;
}

export interface IPendingInvitationProps {
  agents: Array<IAgent>;
}

const PendingInvitation: FunctionComponent<IPendingInvitationProps> = ({
  agents,
}) => {
  const tooltipText = `
    Agencies in this list have been selected<br>
    as members of your audience, but have<br>
    not engaged yet.
  `;

  return (
    <Wrapper>
      <Header data-test-id="pending-invitation-header">
        Pending Invitations
        <ReactTooltip
          html
          place="bottom"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="pending-invitations-tooltip"
        />
        <Tooltip data-tip={tooltipText} data-for="pending-invitations-tooltip">
          <FontAwesomeIcon icon={faInfoCircle} />
        </Tooltip>
      </Header>
      {agents.map((agent) => (
        <AgentWrapper
          key={agent.id}
          data-test-id="pending-invitation-agent-wrapper"
        >
          <AgentDetails>
            <Avatar>
              <AvatarImage src={agent.avatar} alt="Avatar" />
            </Avatar>
            <TextDetails>
              <Name psl={agent.psl}>
                <NameLink
                  href={agent.agentUrl}
                  title={agent.name}
                  data-turbolinks="false"
                >
                  {agent.name}
                </NameLink>
              </Name>
              <Company>{agent.company}</Company>
              <Requested>Active since: {agent.activeSince}</Requested>
              <HHScore>
                HH Score:{" "}
                {agent.isNew ? (
                  "no score yet"
                ) : (
                  <Score data-test-id="hh-score">{agent.hhScore}/10</Score>
                )}
              </HHScore>
              {agent.isNew && (
                <NewBadgeWrapper>
                  <NewBadge data-test-id="hh-new-badge">NEW!</NewBadge>
                </NewBadgeWrapper>
              )}
              {agent.starRatingPercent ? (
                <StarRating className="star-ratings">
                  <StarRatingLabel>Reviews:</StarRatingLabel>
                  <FillRating
                    className="fill-ratings"
                    style={{ width: `${agent.starRatingPercent}%` }}
                  >
                    <Stars>★★★★★</Stars>
                  </FillRating>
                  <EmptyRating className="empty-ratings">
                    <Stars>★★★★★</Stars>
                  </EmptyRating>
                </StarRating>
              ) : (
                <NoRatings>no ratings yet</NoRatings>
              )}
            </TextDetails>
          </AgentDetails>
        </AgentWrapper>
      ))}
    </Wrapper>
  );
};

PendingInvitation.propTypes = {
  agents: awaitingType.isRequired,
};

export default PendingInvitation;
